exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label > a {\n  display: inline-block;\n  font-weight: normal; }\n\nlabel > small {\n  font-size: 92%;\n  color: #777; }\n\n.add-video,\n.add-video:hover,\n.remove-video,\n.remove-video:hover {\n  margin-left: 5px;\n  background-color: #8ac440;\n  border: 1px solid #8ac440;\n  -webkit-appearance: none;\n  color: #fff;\n  text-align: center; }\n\n.remove-video,\n.remove-video:hover {\n  background-color: #c44040;\n  border: 1px solid #c44c40; }\n\n.add-video span,\n.remove-video span {\n  font-size: 2em;\n  line-height: .5em;\n  vertical-align: top; }\n\n.video-block .span3 + .span3 {\n  margin-left: 10px; }\n\n.image-preview__wrapper {\n  margin-top: 22px; }\n\n.form-group.date,\n.form-group.date input {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/projects/add-or-edit/add-or-edit-project.scss
// module id = ../../../../../angular/app/components/projects/add-or-edit/add-or-edit-project.scss
// module chunks = 1